// common widevine, playready and fairplay settings
// = do not change settings
export const widevine = <T>(options: T): T => options
export const playready = <T>(options: T): T => options
export const fairplay = <T>(options: T): T => options
